'use strict';
import Barba from 'barba.js';
import Env from '../base/env.js';
import Channels from '../base/channels'
import Splide from '@splidejs/splide'

let page

class Page
{
    constructor(view='')
    {
        this.view = view
        this.classView = 'currentView--home'
        // Fns
        this.slideshowSkills()
        // Launch Fn
        this.funcLaunch = this.intro.bind(this)
        if(Env.framework.UI.launcher.LAUNCHED == false) this.channels()
    }

    channels()
    {
        Channels.on('launcher::exit',this.funcLaunch)
    }

    destroy()
    {
        Channels.removeListener('launcher::exit', this.funcLaunch);
        if(typeof this.slideshow != 'undefined') {
          this.slideshow.destroy()
        }
    }

    finalize()
    {
        setTimeout(() => {
            if(Env.isVisiting === true) {
                this.intro()
            }
        }, 200);
        setTimeout(() => {
          Env.framework.UI.lazy()
        }, 100);

    }

    intro()
    {
      Env.framework.UI.fxIntro(this.view)
    }

    slideshowSkills()
    {
      const $slideshow = this.view.querySelector('.jsSlideshowSkills--view')
      const $splideView = $slideshow.querySelector('.jsSplide--view')
      const $hovers = $slideshow.querySelectorAll('.jsHover')
      this.slideshow = new Splide($splideView , {
        arrows: false,
        type: 'fade',
        autoplay: false,
        interval: 1000,
        rewind: true,
        pauseOnFocus:false,
        pauseOnHover:false,
        pagination:false,
        easing: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
        speed: 600
      }).mount();
      for(let $hover of $hovers) {
        $hover.addEventListener('mouseover',()=>{
          this.slideshow.go($hover.getAttribute('data-index')*1)
          $splideView.classList.add('is-visible')
        })
        $hover.addEventListener('mouseleave',()=>{
          $splideView.classList.remove('is-visible')
        })
      }
    }
}

page = Barba.BaseView.extend({
    namespace: 'home',
    node: undefined,
    onEnter: function() {
        this.node = new Page(this.container)
        Env.$html.classList.add(this.node.classView)
    },
    onEnterCompleted:function()
    {
        this.node.finalize()
    },
    onLeave: function()
    {
        this.node.destroy()
    },
    onLeaveCompleted: function()
    {
        if(this.container.getAttribute('data-namespace') != this.namespace)
        {
            Env.$html.classList.remove(this.node.classView)
        }
    }
});

export default page;
